export default __webpack_public_path__ + "static/media/GuyAnimation16.364f7e57.svg";